import Vue from "vue";
import Vuex from "vuex";
import VueAxios from "vue-axios";
import axios from "axios";
import { wnbPublicKey, wnbAddress, baseAddressWithWnb } from "../../config";
import CryptoJS from "crypto-js";
import lodash from "lodash";

import jsonwebtoken from "jsonwebtoken";

import main from "../../main";

function deleteTokenIfExpired() {
  let token = localStorage.getItem("token");
  if (token != null && token !== "null") {
    let tokenDecoded = jsonwebtoken.decode(token);
    if (tokenDecoded.exp < new Date().getTime() / 1000) {
      localStorage.removeItem("token");
      localStorage.removeItem("user-property");
    }
  }
}

function isWnbUser() {
  const basePath = window.location.origin.replace(":80", "").replace(":443", "");
  return basePath === baseAddressWithWnb;
  // if (localStorage.getItem('wnb-user') === 'true' || localStorage.getItem('wnb-user') === true) {
  //     return true;
  // }
  // const urlHelper = new URL(window.location.href);
  // if (urlHelper.searchParams.get('external-login') != null) {
  //     return true;
  // }
  // return false;
}

function getWnbUsername(token) {
  //https://github.com/auth0/node-jsonwebtoken
  //return new Promise((resolve, reject) => { // The Promise used for router redirect in login
  let WNB_CERT_PUB_KEY = wnbPublicKey;
  let userName = null;
  jsonwebtoken.verify(token, WNB_CERT_PUB_KEY, function(err, decoded) {
    userName = decoded.user_name;
  });
  return userName;
  //});
}

function loginWnbUserIfNeeded(vueInstance) {
  return new Promise((resolve /*, reject*/) => {
    // fragment z logowaniem zewnętrznym
    let needExternalLog = false;
    if (vueInstance.$store.getters["isWnbUser"]) {
      const urlHelper = new URL(window.location.href);
      let wnbToken = urlHelper.searchParams.get("external-login");
      if (wnbToken != null) {
        let token = localStorage.getItem("token");
        // console.log("test token:");
        // console.log(token);
        if (token == null || token === "null") {
          needExternalLog = true; // jeśli nie ma waznego tokenu w systemie to musi wykonac połączenie
        } else {
          let wnbUsername = localStorage.getItem("wnbUsername");
          // console.log("wnb username:");
          // console.log(wnbUsername);
          if (wnbUsername != null) {
            let wnbUsernameByToken = getWnbUsername(wnbToken);
            // console.log("wnb username By Token:");
            // console.log(wnbUsernameByToken);
            if (wnbUsername !== wnbUsernameByToken) {
              //w wnb zalogowany inny uzytkownik niz w delegacjach!!! zmienic uzytkownika
              needExternalLog = true;
            }
            //albo nie robic nic bo aktualnie zalogowany jest taki sam uzytkownik jak w wnb
          } else {
            //w delegacjach nie ma zalogowanego zadnego zewnetrznego uzytkownika wnb więc zaloguj
            needExternalLog = true;
          }
        }
      }
    }

    if (needExternalLog) {
      externalLoginWnb(vueInstance).then(resp => {
        resolve(resp);
      });
    } else {
      resolve();
    }
  });
}

function externalLoginWnb(vueInstance) {
  const urlHelper = new URL(window.location.href);
  let wnbToken = urlHelper.searchParams.get("external-login");

  if (wnbToken == null) return null;

  window.history.replaceState({}, "", urlHelper.pathname); // usunięcie geta z adresu

  return new Promise((resolve, reject) => {
    // The Promise used for router redirect in login
    vueInstance.$store.commit("AUTH_STATUS", "loading");
    axios
      .post("auth/external-login", { externalLogin: wnbToken })
      .then(resp => {
        const token = resp.data.access_token;
        const user_properties = resp.data.user_properties;
        vueInstance.$store.commit("TOKEN_CHANGE", token);
        vueInstance.$store.commit("USER_DATA_CHANGE", {
          user_properties: user_properties,
          skipSave: false
        });
        //vueInstance.$store.commit('AUTH_STATUS', 'logged'); // todo sprawdzic
        let wnbUsername = getWnbUsername(wnbToken);
        localStorage.setItem("wnbUsername", wnbUsername);
        resolve(resp);
      })
      .catch(err => {
        if (err.response.status === 408 || err.code === "ECONNABORTED") {
          alert("Brak połączenia z serwerem delegacji. Zostaniesz przeniesiony z powrotem na stronę Wyszukiwarki");
          window.location.href = wnbAddress("SEARCH");
        }
        reject(err);
      });
  });
}

function restoreUserProperties(vueInstance, token) {
  let userPropertiesEncoded = localStorage.getItem("user-property");
  let tokenDecoded = jsonwebtoken.decode(token);
  let authKey = tokenDecoded.auth_hash;
  let bytes = CryptoJS.AES.decrypt(userPropertiesEncoded, authKey);
  let user_properties = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  vueInstance.$store.commit("USER_DATA_CHANGE", {
    user_properties: user_properties,
    skipSave: true
  });
}

function storageChanged(storageEvent, vueInstance) {
  if (storageEvent.key === "token") {
    vueInstance.$store.commit("TOKEN_CHANGE", storageEvent.newValue === "null" ? null : storageEvent.newValue);
    if (storageEvent.newValue === "null" || storageEvent.newValue == null) {
      vueInstance.$router.push("/logout");
    }
  } else if (storageEvent.key === "user-property") {
    let token = localStorage.getItem("token");
    let tokenDecoded = jsonwebtoken.decode(token);
    if (tokenDecoded != null) {
      let authKey = tokenDecoded.auth_hash;
      let bytes = CryptoJS.AES.decrypt(storageEvent.newValue, authKey);
      let user_properties = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      vueInstance.$store.commit("USER_DATA_CHANGE", {
        user_properties: user_properties,
        skipSave: true
      });
    }
  } else if (storageEvent.key === "wnbUsername") {
    //todo sprawdzic czy to tylko podczas ładowania ma jakiś wpływ
  } else if (storageEvent.key === "wnb-user") {
    vueInstance.$store.commit("WNB_USER", storageEvent.newValue);
  }
}

export function authOnVueCreated(vueInstance) {
  return new Promise((resolve /*, reject*/) => {
    vueInstance.$store.commit("AUTH_STATUS", "loading");
    window.addEventListener(
      "storage",
      function(storageEvent) {
        storageChanged(storageEvent, vueInstance);
      },
      false
    );

    deleteTokenIfExpired(vueInstance);
    setInterval(deleteTokenIfExpired(vueInstance), 1000);

    vueInstance.$store.commit("WNB_USER", isWnbUser());
    loginWnbUserIfNeeded(vueInstance)
      .then(() => {
        let token = localStorage.getItem("token");
        if (token != null && token !== "null") {
          vueInstance.$store.commit("TOKEN_CHANGE", token);
          restoreUserProperties(vueInstance, token);
          vueInstance.$store.commit("AUTH_STATUS", "logged");
        } else {
          vueInstance.$store.commit("AUTH_STATUS", "notLogged");
        }
        setInterval(function() {
          vueInstance.$store.dispatch("AUTH_REFRESH_TOKEN");
        }, 10000);
      })
      .catch(err => {
        console.log(err);
      });
    //let token = localStorage.getItem('token');
    //let tokenDecoded = jsonwebtoken.decode(token);

    //axios automaticly detect and warn user not allowed for that action
    //axios automaticly logout if token is not valid
    vueInstance.axios.interceptors.response.use(
      response => response,
      error => {
        console.log(error);
        if (typeof error.response !== "undefined") {
          if (error.response.status === 403) {
            vueInstance.$store.dispatch("alertDialog", {
              content: vueInstance.$t("global.noPermissionAlert.content"),
              title: vueInstance.$t("global.noPermissionAlert.title")
            });
          }
          if (error.response.status === 401) {
            vueInstance.$store.dispatch("AUTH_LOGOUT");
          }
        }

        return Promise.reject(error);
      }
    );

    resolve();
  });
}

Vue.use(Vuex);
Vue.use(VueAxios, axios);

const state = {
  userProperties: null,
  token: null,
  status: "notLogged", //TODO SPRAWDZIC!!!
  beforeLoginPath: null,
  wnbUser: null,
  isWnt: localStorage.getItem("isWnt") === "true",
  isWntLoaded: false
};

const getters = {
  isAuthenticated: state => !!state.token,
  isWnbUser: isWnbUser, //  state => state.wnbUser === 'true' || (state.wnbUser === true),
  isAdmin: state => state.userProperties != null && state.userProperties.user_id < 0,
  companyContext: state => (jsonwebtoken.decode(state.token) == null ? null : jsonwebtoken.decode(state.token).company),
  companyContextId: state => (jsonwebtoken.decode(state.token) == null ? null : jsonwebtoken.decode(state.token).company_id),
  authStatus: state => state.status,
  userProperties: state => state.userProperties,
  authToken: state => state.token,
  hasPermission: state => permissionName => {
    if (state.userProperties == null) return false;
    if (typeof state.userProperties.context_user_permissions !== "undefined") {
      return typeof (state.userProperties.context_user_permissions[permissionName] !== "undefined");
    }
    return state.userProperties.permissions[permissionName] !== "undefined";
  }
};

const mutations = {
  AUTH_STATUS: (state, status) => {
    state.status = status; //TODO SPRAWDZIC!!!
  },

  USER_DATA_CHANGE: (state, { user_properties, skipSave }) => {
    state.userProperties = user_properties;
    if (user_properties !== null && user_properties.system_settings.translations_modifications === "andea") {
      main.$i18n.setLocaleMessage("pl", lodash.merge(main.$i18n.messages.pl, require("../../lang/andea/pl.json")));
      main.$i18n.setLocaleMessage("en", lodash.merge(main.$i18n.messages.en, require("../../lang/andea/en.json")));
    } else {
      main.$i18n.setLocaleMessage("pl", lodash.merge(main.$i18n.messages.pl, require("../../lang/pl.json")));
      main.$i18n.setLocaleMessage("en", lodash.merge(main.$i18n.messages.en, require("../../lang/en.json")));
    }
    if (skipSave === false || skipSave === "false") {
      let tokenDecoded = jsonwebtoken.decode(state.token);
      if (tokenDecoded != null) {
        let authKey = tokenDecoded.auth_hash;
        let encryptedData = CryptoJS.AES.encrypt(JSON.stringify(user_properties), authKey).toString();
        localStorage.setItem("user-property", encryptedData);
      } else {
        localStorage.setItem("user-property", null);
      }
    }
  },

  WNB_USER: (state, wnbUser) => {
    localStorage.setItem("wnb-user", wnbUser);
    state.wnbUser = wnbUser;
  },

  TOKEN_CHANGE: (state, newToken) => {
    state.token = newToken;
    axios.defaults.headers.common["Authorization"] = newToken;
    localStorage.setItem("token", newToken);
  },

  SET_LANG: (state, newLanguage) => {
    main.$i18n.locale = newLanguage;
    localStorage.setItem("language", newLanguage);
  },

  SET_IS_WNT: (state, isWnt) => {
    state.isWnt = isWnt;
    state.isWntLoaded = true;
    localStorage.setItem("isWnt", isWnt);
  }
};

const actions = {
  AUTH_REQUEST: ({ commit /*, dispatch*/ }, user) => {
    return new Promise((resolve, reject) => {
      // The Promise used for router redirect in login
      commit("AUTH_STATUS", "loading");
      axios({ url: "auth/login", data: user, method: "POST" })
        .then(resp => {
          const token = resp.data.access_token;
          const user_properties = resp.data.user_properties;
          commit("TOKEN_CHANGE", token);
          commit("USER_DATA_CHANGE", { user_properties, skipSave: false });
          commit("AUTH_STATUS", "logged");
          resolve(resp);
        })
        .catch(err => {
          commit("AUTH_STATUS", "notLogged");
          commit("USER_DATA_CHANGE", {
            user_properties: null,
            skipSave: false
          });
          commit("TOKEN_CHANGE", null);
          console.log(err);
          reject(err);
        });
    });
  },

  AUTH_LOGOUT: ({ commit /*, dispatch */ }) => {
    return new Promise((resolve /*, reject*/) => {
      main.$router.push("/login/" + encodeURIComponent(main.$route.fullPath.substring(1)));
      commit("USER_DATA_CHANGE", { user_properties: null, skipSave: false });
      commit("TOKEN_CHANGE", null);
      localStorage.setItem("wnbUsername", null);
      commit("AUTH_STATUS", "notLogged");
      resolve();
    });
  },

  AUTH_LOGIN_AS: ({ commit /*, dispatch */ }, absentUserId) => {
    return new Promise((resolve, reject) => {
      axios
        .post("user-substitute/login-as", { absent_user_id: absentUserId })
        .then(resp => {
          const token = resp.data.access_token;
          const user_properties = resp.data.user_properties;
          commit("USER_DATA_CHANGE", { user_properties, skipSave: false });
          commit("TOKEN_CHANGE", token);
          commit("AUTH_STATUS", "logged");
          resolve(resp);
        })
        .catch(() => {
          reject();
          // commit('AUTH_ERROR', err);
          // localStorage.removeItem('user-token');
          // localStorage.removeItem('user-company');
          // delete axios.defaults.headers.common['Authorization'];
          // reject(err)
        });
    });
  },

  AUTH_LOGIN_BACK: ({ commit /*, dispatch */ }) => {
    return new Promise((resolve, reject) => {
      main
        .axios({
          url: "user-substitute/login-back",
          data: null,
          method: "POST"
        })
        .then(resp => {
          const token = resp.data.access_token;
          const user_properties = resp.data.user_properties;
          commit("USER_DATA_CHANGE", { user_properties, skipSave: false });
          commit("TOKEN_CHANGE", token);
          resolve(resp);
        })
        .catch(err => {
          console.log(err);
          reject(err);
          commit("USER_DATA_CHANGE", {
            user_properties: null,
            skipSave: false
          });
          commit("TOKEN_CHANGE", null);
          commit("AUTH_STATUS", "notLogged");
        });
    });
  },

  AUTH_REFRESH_TOKEN: ({ commit, dispatch, state }) => {
    return new Promise((resolve, reject) => {
      // The Promise used for router redirect in login
      if (state.token != null) {
        let tokenDecoded = jsonwebtoken.decode(state.token);

        let currentTimeInSeconds = new Date().getTime() / 1000;
        let lastActivityTime = parseInt(localStorage.getItem("lastActivityTime"));

        let tokenExist = tokenDecoded != null;
        let tokenExpirationTime = tokenDecoded.exp - 60 < currentTimeInSeconds; // TOKEN EXPIRATION TIME LESS THAN MINUTE

        let sessionTime = 30;
        // eslint-disable-next-line no-extra-boolean-cast
        if (!!main.$store.getters["userProperties"].system_settings) {
          sessionTime = main.$store.getters["userProperties"].system_settings.session_time;
        }

        let lastActivityOK = currentTimeInSeconds - lastActivityTime < 60 * sessionTime; // NOT IDLE MORE THAN 30 minutes

        if (tokenExist && tokenExpirationTime && lastActivityOK) {
          //commit('AUTH_STATUS', 'loading');
          axios({ url: "token-refresh/get", method: "GET" })
            .then(resp => {
              const token = resp.data.token;
              commit("TOKEN_CHANGE", token);
              dispatch("AUTH_UPDATE_SETTINGS");
              resolve(resp);
            })
            .catch(err => {
              commit("TOKEN_CHANGE", null);
              commit("USER_DATA_CHANGE", {
                user_properties: null,
                skipSave: false
              });
              localStorage.removeItem("wnbUsername");
              commit("AUTH_STATUS", "notLogged");
              reject(err);
            });
        }
      }
    });
  },

  AUTH_UPDATE_SETTINGS({ commit }) {
    return new Promise((resolve, reject) => {
      // The Promise used for router redirect in login
      // commit('AUTH_REQUEST');
      axios({ url: "token-refresh/user-properties", method: "GET" })
        .then(resp => {
          commit("USER_DATA_CHANGE", {
            user_properties: resp.data,
            skipSave: false
          });
          resolve(resp);
        })
        .catch(err => {
          //TODO sprawdzic
          reject(err);
        });
    });
  },

  CHOOSE_LANGUAGE({ commit }, newLanguage) {
    commit("SET_LANG", newLanguage);
    //TODO AXIOS ZAPIS DOMYSLNEGO I UPDATE SETTINGS
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
